import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatSelectionList } from '@angular/material/list';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { AmazonItems } from 'src/app/interfaces/amazondata';
import { AmazonServices } from 'src/app/services/AmazonServices';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { AmazonErrorMessageComponent } from '../../amazon-error-message/amazon-error-message.component';
import { ThemeService } from 'src/app/services/theme.service';


@Component({
    selector: 'criacao-produto-form',
    templateUrl: './criacao-produto-form.component.html',
    styleUrls: ['./criacao-produto-form.component.css'],
    standalone: false
})


export class CriacaoProdutoFormComponent implements OnInit,OnDestroy {
  produtosCatalogo: Object[] = [];
  showQuestion: boolean;
  selectedClass:{classificationId:string; displayName:string; numberOfResults:number}[] = [];
  selectedBrands: {brandName:string, numberOfResults:number}[] = [];
  brands:{brandName:string, numberOfResults:number}[] = [];
  class:{classificationId:string; displayName:string; numberOfResults:number}[] = [];
  showFilter = false;
  nextToken: string;
  numberOfResults: number;
  removable = true;
  amazonItems:AmazonItems[] = [];
  newMode: boolean = false;
  asin:string;
  codecompany;

  constructor(private formBuilder:UntypedFormBuilder,
    private spinner:NgxSpinnerService,
    private snackBar:SnackbarService,
    private http:HTTPService,
    private us:UserAuthenticationServices,
    private amazonServices:AmazonServices,
    private dialogServices:DialogService,
    public ThemeService:ThemeService ) { }
  
    ngOnDestroy(): void {
      if ( this.subscription!= null ){ this.subscription.unsubscribe();}
      if ( this.sub4!= null ){ this.sub4.unsubscribe();}
    }
  
    selectedAsin = false;
    searchMode  = true;
    firstFormGroup:UntypedFormGroup;
    showCatalogoProducts = false;
    @Input('data') data:any;
    $$REFERENCES;
    formViewColumns;
    parentRow;
    entityName;
    row;
    filter;
    userConfig;
    tableInformation;
    canConfig;
    actionList;
    evento:string;
    customComponents;
    dataMultiTableConfig;
    formGroup:UntypedFormGroup;
    @Input() forceParentRow: string;
    @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();
    @ViewChild('marca',{read:MatSelectionList}) marca:MatSelectionList;
    @ViewChild('cl',{read:MatSelectionList}) cl:MatSelectionList;
    private modelChanged: Subject<string> = new Subject<string>();
    private subscription: Subscription;
    debounceTime = 1000;
    public change: Subject<boolean> = new Subject();
    sub4:Subscription;

  salvandoPrincipal(evento){
      this.saving.emit(evento);
  }

  inputChanged(){
    this.modelChanged.next("alterado");
  }


  ngOnInit(): void {
      
      this.formGroup = this.formBuilder.group({});
      this.subscription = this.modelChanged
        .pipe(
          debounceTime(this.debounceTime),
        )
        .subscribe(() => {
          this.clearFilters();
      });

      this.firstFormGroup =  this.formBuilder.group({
        productSearch: ''
      });
      
      if ( this.us.user.companylist.length == 1 ){
        this.codecompany = this.us.user.codecompany;
      }
      
      this.evento = this.data.evento;
      this.formGroup = this.data.formGroup;
      this.actionList =this.data.actionList;
      this.forceParentRow = this.data.forceParentRow;
      this.$$REFERENCES = this.data.$$REFERENCES;
      this.parentRow = this.data.parentRow;
      this.formViewColumns = this.data.formViewColumns;
      this.entityName = this.data.entityName;
      this.row = this.data.row;
      this.filter = this.data.filter;
      this.userConfig = this.data.userConfig;
      this.tableInformation = this.data.tableInformation;
      this.canConfig = this.data.canConfig
      this.customComponents = this.data.customComponents;
      this.dataMultiTableConfig= this.data.dataMultiTableConfig;

      if ( this.evento =='editando'){
        this.searchMode = false;  
      }
      
      /*this.data = {
          parentRow:{
              linha:{
                  CODEPRODUCT:this.codeProduct,
                  CODECONTRACT:this.codeContract,
              }
          },
          row:{
              CODEMELI:1,
              CODECOMPANY: this.codeCompany
          },
          evento:'inserindo',
          formGroup: this.formGroup
      }*/
  }

  clearFilters(){
    this.brands = [];
    this.class = [];
    this.nextToken = '';
    this.numberOfResults = 0;
  }

  buscaProduto(){
      let desc = this.firstFormGroup.get('searchCatalogo').value;

      let isIdentifier = false;
      try{
        if ( Number.isNaN(Number(desc))){
          isIdentifier = false;
        }else{
          isIdentifier = true;
        }
        
      }catch(Exception){
        throw(Exception)
      }

  }

  novoAnuncio(){
    this.searchMode  = false;
    setTimeout(()=>{
      this.formGroup.get('TYPE').patchValue('new');
    },100);
    this.newMode = true;
  }

  async selectProduct(data){
      
      this.asin = data['asin'];
      this.spinner.show(this.asin);
      await this.checkRestriction().then((body:Object)=>{
        let restrictions:Object[] = body['restrictions'] as Object[];

        if ( restrictions.length > 0 ){
          this.dialogServices.openGenericDialog(AmazonErrorMessageComponent,restrictions,(data)=>{},
          ()=>{},'60vh','60vw',false,null,'S','80px');

        }else{
          this.searchMode  = false;
          
          setTimeout(()=>{
            this.formGroup.get('TYPE').patchValue('match');
            this.formGroup.get('ASIN').patchValue(this.asin);
            this.selectedAsin = true;
          },100);
        }
      }).finally(()=>{
          this.spinner.hide(this.asin);
      });
      
      
  }
  checkRestriction() {
    return this.amazonServices.getRestrictions(this.asin,'new_new',this.codecompany);
  }

  pesquisar(proximo:boolean, event){
    if ( event !=null){
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    if ( this.codecompany )

    if ( !ObjectUtil.isNotEmpty(this.firstFormGroup.get("productSearch").value) ){
      this.snackBar.showError("Necessário informar Nome, ASIN ou EAN para pesquisa.");
      return;
    }else{

      let ob= {
        codecompany:this.codecompany,//this.uas.user.codecompany,
        params:[{
          key:'keywords',
          value: this.firstFormGroup.get('productSearch').value
          },
          {
            key:'includedData',
            value:'{identifiers,summaries,images,variations,salesRanks}'
          }
        ]
      }

      if ( proximo && this.nextToken != ""){
          ob['params'].push({
              key:'nextToken',
              value:this.nextToken
          })
      }

      if ( this.selectedBrands.length > 0 ){
          let strBrands:string[]= [];
          this.selectedBrands.forEach(b=>{
            strBrands.push(b.brandName);
          })

          ob['params'].push({
            key:'brandNames',
            value:`{${strBrands.join(',')}}`
          })
      }

      if ( this.selectedClass.length > 0 ){
        let strClass:string[] = [];
        this.selectedClass.forEach(b=>{
          strClass.push(b.classificationId);
        })

        ob['params'].push({
          key:'classificationIds',
          value:`{${strClass.join(',')}}`
        })
      }

      this.nextToken = "";
      this.numberOfResults = 0; 
      this.spinner.show('amselect');
      this.subscription = this.http.post(ob,'AmazonServices/listCatalogItems',false,true,false).subscribe(data=>{
        
        if  ( proximo ){
            this.addItens(data['resultado']['items'] as AmazonItems[]);
        }else{
          
          this.amazonItems = [];
          
          if ( this.cl != null ){
            this.cl.deselectAll();
          }

          if ( this.marca != null){
            this.marca.deselectAll();
          }
          
          //this.selectedClass = [];
          //this.selectedBrands = [];

          
          this.amazonItems = data['resultado']['items'] as AmazonItems[];
          this.loadBrand(data['resultado']);
          this.loadClass(data['resultado']);

          if ( this.selectedBrands.length > 0 ){
              this.selectedBrands.forEach(val=>{
                this.marca.options.forEach(op=>{
                  if ( op.value == val){
                    op.selected = true;
                  }else{
                    op.selected = false;
                  }
                })
              })
          }

          
          if ( this.selectedClass.length > 0 ){
            this.selectedClass.forEach(val=>{
              this.cl.options.forEach(op=>{
                if ( op.value == val){
                  op.selected = true;
                }else{
                  op.selected = false;
                }
              })
            })
        }

          this.showFilter = true;
        }
          

        if ( ObjectUtil.isNotEmpty(data['resultado']['pagination'])){
          if ( ObjectUtil.isNotEmpty(data['resultado']['pagination']['nextToken'])){
            this.nextToken = data['resultado']['pagination']['nextToken']
          }
        }
        
        this.numberOfResults = data['resultado']['numberOfResults']
        this.spinner.hide('amselect');
      },
      (error)=>{
        this.spinner.hide('amselect');
        throw error;
      });
    }

}

addItens(data:AmazonItems[]){
    if ( ObjectUtil.isNotEmpty(data)){
        data.forEach( item=>{
          if (this.amazonItems.indexOf(item) == -1 ){
            this.amazonItems.push(item);
          }
        })
    }
}

loadBrand(data){
    if ( this.brands.length == 0){
      if ( ObjectUtil.isNotEmpty(data['refinements'])){
        if ( ObjectUtil.isNotEmpty(data['refinements']['brands'])){
            this.brands =  data['refinements']['brands'];
        }
      }
    } 
}

loadClass(data){

  if ( this.class.length == 0){
    if ( ObjectUtil.isNotEmpty(data['refinements'])){
      if ( ObjectUtil.isNotEmpty(data['refinements']['classifications'])){
          this.class = data['refinements']['classifications'];
      }
    }
  }
}
}
